import { defineStore } from 'pinia';
import api from '../utils/api';

export const useCompaniesStore = defineStore('companies', {
  state: () => ({
    companies: [],
    loading: false,
    error: null,
    loaded: false, // to track if data has been loaded
    loadPromise: null, // to handle concurrent loads
  }),

  getters: {
    getCompanyById: (state) => (id) => {
      return state.companies.find(company => company.id === id);
    },
  },

  actions: {
    async loadCompanies(force = false) {
      if (this.loaded && !force) {
        return this.companies;
      }

      // If already loading, return the existing promise
      if (this.loadPromise) {
        return this.loadPromise;
      }

      this.loadPromise = this._loadCompanies(force);
      const result = await this.loadPromise;
      this.loadPromise = null;
      return result;
    },

    async _loadCompanies(force = false) {
      this.loading = true;
      this.error = null;

      try {
        const response = await api.get('/api/companies');
        this.companies = response.data.data || response.data;
        this.loaded = true;
        return this.companies;
      } catch (err) {
        this.error = err.response?.data?.message || 'Failed to load companies';
        console.error('Failed to load companies:', err);
        return [];
      } finally {
        this.loading = false;
      }
    },

    async createCompany(companyData) {
      try {
        const response = await api.post('/api/companies', companyData);
        this.companies.push(response.data);
        return response.data;
      } catch (err) {
        this.error = err.response?.data?.message || 'Failed to create company';
        throw err;
      }
    },

    async deleteCompany(companyId) {
      try {
        await api.delete(`/api/companies/${companyId}`);
        this.companies = this.companies.filter(c => c.id !== companyId);
        
        // Clear from localStorage if it was the selected company
        const selectedCompanyId = localStorage.getItem('selectedCompanyId');
        if (selectedCompanyId && parseInt(selectedCompanyId) === companyId) {
          localStorage.removeItem('selectedCompanyId');
        }
        
        return true;
      } catch (err) {
        this.error = err.response?.data?.message || 'Failed to delete company';
        throw err;
      }
    },

    // Add other methods as needed
  },
});